import { API_ENDPOINTS } from "../constants";
import { apisClient as api } from "./api";

export const fetchAvailability = () =>
  api.get(`${API_ENDPOINTS.ECOMMERCE}/availability`);

export const generateAuthToken = () =>
  api.get(`${API_ENDPOINTS.ECOMMERCE}/customer/auth`);
